<template>
    <div class="search">
        <label for="search-input">Search:</label>
        <input id="search-input" ref="input" type="text" v-model="app.q" @keyup="filterNodes()" autocomplete="off">

        <br><br>

        <ul class="results">
            <li v-for="node in filteredNodes" :key="Math.random() + node.content">
                <node
                    :node="node"
                    :app="app"
                    :toggler="toggler"
                />
            </li>
        </ul>

        <p v-if="!filteredNodes.length">
            Hint: Use "tag:Todo" to find all todos.
        </p>
    </div>
</template>

<script>
import Node from '../node/component.vue';

function search(nodes, arr, func) {
    nodes.forEach(function(node) {
        if (func(node)) {
            arr.push(node);
        }

        if (node.children && node.children.length) {
            search(node.children, arr, func);
        }
    });

    return arr;
}

function _search(qLower) {
    return function __search(node) {
        return (node.value || node.content || '').toLowerCase().indexOf(qLower) !== -1;
    };
}

function _searchWithTag(qLower, tag) {
    return function __searchWithTag(node) {
        return node.value && node.value.indexOf(`${tag} `) === 0 && (!qLower || _search(qLower)(node));
    };
}

var KEYUP_TIMEOUT;

export default {
    props: ['app', 'rootNode', 'toggler'],
    components: {
        Node
    },
    mounted() {
        var _ = this;
        _.filterNodes(true);
        _.$refs.input.focus();
    },
    data() {
        return {
            filteredNodes: []
        };
    },
    methods: {
        filterNodes(withoutDelay) {
            var _ = this;

            clearTimeout(KEYUP_TIMEOUT);

            KEYUP_TIMEOUT = setTimeout(function() {
                if (_.app.q.length < 3) {
                    _.filteredNodes = [];
                    return;
                }

                var qLower = _.app.q.toLowerCase(),
                    tagFound = /tag:([A-Z\s]+)/i.exec(_.app.q),
                    tag = tagFound ? tagFound[1].toUpperCase().trim() : undefined;

                if (tag) {
                    qLower = _.app.q.replace(/tag:([a-z\s]+)/i, '').trim();
                }

                _.filteredNodes = search(
                    _.rootNode ? _.rootNode.children : [],
                    [],
                    tag ? _searchWithTag(qLower, tag) : _search(qLower)
                );
            }, withoutDelay ? 0 : 400);
        }
    }
};
</script>
